/**
 * FridgeIQ — useMachines hook
 * Fetches machine metadata from DynamoDB fridgeiq-machines table.
 */

import { useState, useEffect, useCallback } from "react";
import { getMachines } from "../services/dynamodb";

const MACHINE_IDS = (process.env.REACT_APP_MACHINE_IDS || "FIQ-001,FIQ-002").split(",");

export function useMachines() {
  const [machines, setMachines]   = useState({});
  const [loading, setLoading]     = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    const data = await getMachines(MACHINE_IDS);
    const map  = {};
    data.forEach(m => { map[m.machine_id] = m; });
    setMachines(map);
    setLoading(false);
  }, []);

  useEffect(() => { load(); }, [load]);

  return { machines, loading, refresh: load };
}
